export type StoredMislMember = {
  id: string
  name: string
  handle: string
  role: 'founder' | 'member'
  joinedAt: string
}

export type StoredMisl = {
  name: string
  region: string
  members: StoredMislMember[]
  createdAt: number
  target: number
}

const KEY = 'lahore-treasury:founding-misl'

const isBrowser = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

export const getMisl = (): StoredMisl | null => {
  if (!isBrowser()) return null
  try {
    const raw = window.localStorage.getItem(KEY)
    if (!raw) return null
    return JSON.parse(raw) as StoredMisl
  } catch {
    return null
  }
}

export const setMisl = (misl: StoredMisl) => {
  if (!isBrowser()) return
  try {
    window.localStorage.setItem(KEY, JSON.stringify(misl))
    window.dispatchEvent(new CustomEvent('mislStore:change'))
  } catch {
    // no-op
  }
}

export const clearMisl = () => {
  if (!isBrowser()) return
  try {
    window.localStorage.removeItem(KEY)
    window.dispatchEvent(new CustomEvent('mislStore:change'))
  } catch {
    // no-op
  }
}

export const subscribeMisl = (cb: () => void): (() => void) => {
  if (!isBrowser()) return () => {}
  const handler = () => cb()
  window.addEventListener('mislStore:change', handler)
  window.addEventListener('storage', handler)
  return () => {
    window.removeEventListener('mislStore:change', handler)
    window.removeEventListener('storage', handler)
  }
}
